module.exports = __webpack_public_path__ + "img/NHaasGroteskTXPro-65Md.19b859e.svg";